export var PermissionSetObjectType = /*#__PURE__*/ function(PermissionSetObjectType) {
    PermissionSetObjectType["Account"] = "ACCOUNT";
    PermissionSetObjectType["Project"] = "PROJECT";
    return PermissionSetObjectType;
}({});
export var ProjectPermissionSetType = /*#__PURE__*/ function(ProjectPermissionSetType) {
    ProjectPermissionSetType[ProjectPermissionSetType["Owner"] = 2] = "Owner";
    ProjectPermissionSetType[ProjectPermissionSetType["VendorCollaborator"] = 3] = "VendorCollaborator";
    ProjectPermissionSetType[ProjectPermissionSetType["CustomerCollaborator"] = 4] = "CustomerCollaborator";
    ProjectPermissionSetType[ProjectPermissionSetType["CustomerChampion"] = 5] = "CustomerChampion";
    ProjectPermissionSetType[ProjectPermissionSetType["Observer"] = 6] = "Observer";
    return ProjectPermissionSetType;
}({});
export var AccountPermissionSetType = /*#__PURE__*/ function(AccountPermissionSetType) {
    AccountPermissionSetType[AccountPermissionSetType["Admin"] = 1] = "Admin";
    AccountPermissionSetType[AccountPermissionSetType["SuperUser"] = 7] = "SuperUser";
    AccountPermissionSetType[AccountPermissionSetType["VendorCollaborator"] = 8] = "VendorCollaborator";
    AccountPermissionSetType[AccountPermissionSetType["CustomerCollaborator"] = 10] = "CustomerCollaborator";
    // Partner permission types (account-scoped)
    AccountPermissionSetType[AccountPermissionSetType["PartnerAdmin"] = 11] = "PartnerAdmin";
    AccountPermissionSetType[AccountPermissionSetType["PartnerMember"] = 12] = "PartnerMember";
    AccountPermissionSetType[AccountPermissionSetType["PartnerCollaborator"] = 13] = "PartnerCollaborator";
    AccountPermissionSetType[AccountPermissionSetType["PermissivePartnerAdmin"] = 24] = "PermissivePartnerAdmin";
    AccountPermissionSetType[AccountPermissionSetType["PermissivePartnerMember"] = 26] = "PermissivePartnerMember";
    AccountPermissionSetType[AccountPermissionSetType["ModeratePartnerAdmin"] = 28] = "ModeratePartnerAdmin";
    AccountPermissionSetType[AccountPermissionSetType["ModeratePartnerMember"] = 30] = "ModeratePartnerMember";
    AccountPermissionSetType[AccountPermissionSetType["RestrictivePartnerAdmin"] = 32] = "RestrictivePartnerAdmin";
    AccountPermissionSetType[AccountPermissionSetType["RestrictivePartnerMember"] = 34] = "RestrictivePartnerMember";
    AccountPermissionSetType[AccountPermissionSetType["PesPmo"] = 100] = "PesPmo";
    AccountPermissionSetType[AccountPermissionSetType["Finance"] = 102] = "Finance";
    AccountPermissionSetType[AccountPermissionSetType["Management"] = 104] = "Management";
    AccountPermissionSetType[AccountPermissionSetType["RegionalManager"] = 106] = "RegionalManager";
    AccountPermissionSetType[AccountPermissionSetType["ProjectManager"] = 108] = "ProjectManager";
    AccountPermissionSetType[AccountPermissionSetType["User"] = 110] = "User";
    AccountPermissionSetType[AccountPermissionSetType["Director"] = 112] = "Director";
    AccountPermissionSetType[AccountPermissionSetType["CustomerSuccess"] = 114] = "CustomerSuccess";
    AccountPermissionSetType[AccountPermissionSetType["CustomerPartnerAdmin"] = 20] = "CustomerPartnerAdmin";
    AccountPermissionSetType[AccountPermissionSetType["CustomerPartnerCollaborator"] = 22] = "CustomerPartnerCollaborator";
    return AccountPermissionSetType;
}({});
export const DEFAULT_ACCOUNT_PERMISSION_SET = [
    7,
    8
];
export const DEFAULT_PROJECT_PERMISSION_SET = [
    2,
    5
];
